// @ts-nocheck
import * as FlatModels from '@medsurf/flat-models';
import { KeymapSelftest } from '../elements/marker/keymapSelftest';
import { Freeform } from '../elements/freeform/freeform';
import { Tool } from './tool';

let _preventMoving;

/**
 * MarkerTool class
 */
export class MarkerTool extends Tool {
  /**
   * Members
   */
  private _hitOptions: { fill: boolean; stroke: boolean; tolerance: number; segments: boolean };
  private sequenceId: number;
  private layerId: number;
  private _cmdPressed: boolean;
  private _ctrlPressed: boolean;
  private selfMarker: any;
  private _segment: any;
  private _lockimage: any;
  private _lastPoint: any;
  private _hitResults: any;
  private _hitResult: any;
  private self: this;
  private _startPoints: any;
  private _isMouseDown: boolean;
  private _emitData: any = null;

  /**
   * Constructor
   *
   * @param localPaper
   * @param container
   * @param $window
   * @param slide
   * @param _imageScale
   * @param _imageOffset
   */
  public constructor(localPaper,
                     container,
                     private $window,
                     private slide,
                     private _imageScale = 1,
                     private _imageOffset?) {
    super('MarkerTool', localPaper, null, null, null, container);
    this._hitOptions = {
      segments: true,
      stroke: true,
      fill: true,
      tolerance: 5
    };
    this._init();
    this.sequenceId = 0;
    this.layerId = 0;
  }

  /**
   * Init
   *
   * @protected
   */
  protected _init() {
    super._init();
    this._cmdPressed = false;
    this._ctrlPressed = false;
    this.tool['self'] = this;
    this._tool.on({
      mousemove: this._handleMouseMove,
      mousedown: this._handleMouseDown,
      mousedrag: this._handleMouseDrag,
      mouseup: this._handleMouseUp,
      keyup: this._keyUp.bind(this),
      keydown: this._keyDown.bind(this)
    });
    this.selfMarker = this;
  }

  /**
   * Event kesy down
   *
   * @param event
   * @protected
   */
  protected _keyDown({event}) {
	  if (event.target === document.body || !event.target.contains(this._localPaper.view.element)) {
		  return;
	  }
	  if (event.keyCode === 91) {
      this.selfMarker._cmdPressed = true;
    }
    if (event.keyCode === 17) {
      this.selfMarker._ctrlPressed = true;
    }
    if (event.keyCode === 65 && (this.selfMarker._cmdPressed || event.ctrlKey)) {
      event.preventDefault();
      this.selfMarker.emit('selectAllMarkers');
    }
    this.selfMarker._updateSelectedItems(event);
  }

  /**
   * Command move label
   *
   * @param marker
   * @param value
   * @protected
   */
  protected _commandMoveLabel(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                              value) {
    marker.model.source.position = value;
    this._emitData = {
      type: 'updateMarkerSource',
      data: {
        source: marker.model.source,
        name: 'history.marker_update_source_position'
      }
    };
    this.emit('updateAnnotation');
  }

  /**
   * Command move target
   *
   * @param marker
   * @param index
   * @param value
   * @protected
   */
  protected _commandMoveTarget(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                               index,
                               value) {
    marker.model.targets[index].position.x += value.x;
    marker.model.targets[index].position.y += value.y;
    this._emitData = {
      type: 'updateMarkerTarget',
      data: {
        target: marker.model.targets[index],
        name: 'history.marker_update_target_position'
      }
    };
    this.emit('updateAnnotation');
  }

  /**
   * Command move image
   *
   * @param image
   * @param value
   * @protected
   */
  protected _commandMoveImage(image,
                              value) {
    image.offset = value;
    this.emit('updateAnnotation');
  }

  /**
   * Command move fork
   *
   * @param marker
   * @param value
   * @protected
   */
  protected _commandMoveFork(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                             value) {
    marker.model.annotation.fork = value;
    /*
    this._command.doCommand(function (data) {
      marker.model.annotation.fork = value;
      return data;
    }, 'moveFork');
    */
    this._emitData = {
      type: 'updateMarkerFork',
      data: {
        marker: marker.model.annotation,
        name: 'history.marker_update_fork_position'
      }
    };
    this.emit('updateAnnotation');
  }

  /**
   * Command move pointer
   *
   * @param marker
   * @param value
   * @protected
   */
  protected _commandMovePointer(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                                value) {
    for (const target of marker.model.targets) {
      target.position.x += value.x;
      target.position.y += value.y;
    }
    if (marker.model.label) {
      marker.model.source.position.x += value.x;
      marker.model.source.position.y += value.y;
    }
    if (marker.model.annotation && marker.model.annotation.fork) {
      if (marker.model.annotation.fork.x) {
        marker.model.annotation.fork.x += value.x;
      }
      if (marker.model.annotation.fork.y) {
        marker.model.annotation.fork.y += value.y;
      }
    }
    /*
    this._command.doCommand(function (data) {
      for (const target of marker.model.targets) {
        target.x += value.x;
        target.y += value.y;
      }
      if (marker.model.label) {
        marker.model.source.x += value.x;
        marker.model.source.y += value.y;
      }
      if (marker.model.annotation && marker.model.annotation.fork) {
        marker.model.annotation.fork.x += value.x;
        marker.model.annotation.fork.y += value.y;
      }
      return data;
    }, 'movePointer');
    */
    this._emitData = {
      type: 'updateMarker',
      data: {
        marker: marker.model.annotation,
        source: marker.model.source,
        targets: marker.model.targets,
        name: 'history.marker_update'
      }
    };
    this.emit('updateAnnotation');
  }

  /**
   * Command move keymap
   *
   * @param keymap
   * @param value
   * @protected
   */
  protected _commandMoveKeymap(keymap: { model: FlatModels.ImageSharedModels.KeymapModel },
                               value) {
    if (keymap instanceof KeymapSelftest) {
      /*TODO
      throw "_commandMoveKeymap_not_implemented";
      keymap.model.addSelftest(value);
      this.emit('updateKeymapSource', {
        source: keymap.model.source,
        name: 'history.keymap_update_source_position'
      });
      this._command.doCommand(function (data) {
        keymap.model.addSelftest(value);
        return data;
      }, 'moveKeymapSelftest');
      */
    } else {
      keymap.model.source.position.x += value.x;
      keymap.model.source.position.y += value.y;
      this._emitData = {
        type: 'updateKeymapSource',
        data: {
          source: keymap.model.source,
          name: 'history.keymap_update_source_position'
        }
      };
    }

    this.emit('updateAnnotation');
  }

  /**
   * Command move object
   *
   * @param freeform
   * @param value
   * @param relativePos
   * @protected
   */
  protected _commandMoveObject(freeform: { model: FlatModels.ImageSharedModels.FreeformModel },
                               value,
                               relativePos) {
    this._addSource(freeform.model, value);
    this.emit('updateAnnotation');
  }

  /**
   * Command move segment
   *
   * @param freeform
   * @param relativeDelta
   * @param relativePos
   * @protected
   */
  protected _commandMoveSegment(freeform: { model: FlatModels.ImageSharedModels.FreeformModel },
                                relativeDelta,
                                relativePos) {
    this._moveSegment(freeform.model, relativeDelta, relativePos);
    this.emit('updateAnnotation');
  }

  /**
   * Command resize freeform
   *
   * @param freeform
   * @param value
   * @protected
   */
  protected _commandResizeFreeform(freeform: { model: FlatModels.ImageSharedModels.FreeformModel },
                                   value) {
    this._resize(freeform.model, value);
    this.emit('updateAnnotation');
  }

  /**
   * Command move multiple items
   *
   * @param elements
   * @param value
   * @protected
   */
  protected _commandMoveMultipleItems(elements,
                                      value) {
    const annotations = [];
    for (const element of elements) {
      if (element instanceof Freeform) {
        this._addSource(element.model, value);
      } else {
        element.model.source.position.x += value.x;
        element.model.source.position.y += value.y;
        if (element.model.annotation.targets) {
          for (const targetId of element.model.annotation.targets) {
            const target = element.model.targets.find((t) => t.id === targetId);
            if (target) {
              target.x += value.x;
              target.y += value.y;
            }
          }
        }
        if (element.model.annotation && element.model.annotation.fork) {
          if (element.model.annotation.fork.x) {
            element.model.annotation.fork.x += value.x;
          }
          if (element.model.annotation.fork.y) {
            element.model.annotation.fork.y += value.y;
          }
        }
      }
      annotations.push(element.model);
      element.draw();
    }
    this.emit('updateMoveMultipleAnnotations', {
      annotations,
      name: 'history.annotation_move_multiple'
    });
    this.emit('updateAnnotation');
  }

  /**
   * Command move virtualpointer
   *
   * @param virtualPointer
   * @param value
   * @protected
   */
  protected _commandMoveVirtualPointer(virtualPointer,
                                       value) {
    virtualPointer.model.offset.x += value.x;
    virtualPointer.model.offset.y += value.y;
    /*
    this._command.doCommand(function (data) {
      virtualPointer.model.offset.x += value.x;
      virtualPointer.model.offset.y += value.y;
      return data;
    }, 'moveVirtualPointer');
    */
    this.emit('updateVirtualPointer', {item: virtualPointer});
  }

  /**
   * Update selected items
   *
   * @param event
   * @protected
   */
  protected _updateSelectedItems(event) {
    const multiplier = (event.shiftKey) ? 0.1 : 0.01;
    const step = multiplier / (this._container.width / this._localPaper.view.size.width);
    let stepX = 0, stepY = 0;
    // Arrow Up
    if (event.keyCode === 38) {
      stepY = -step;
    }
    // Arrow Down
    if (event.keyCode === 40) {
      stepY = step;
    }
    // Arrow Right
    if (event.keyCode === 39) {
      stepX = step;
    }
    // Arrow Left
    if (event.keyCode === 37) {
      stepX = -step;
    }
    // Only Move Items when Arrow Key Pressed
    if ((stepX !== 0 || stepY !== 0) && this._container.selection.length > 0) {
      this.moveMultibleItems(stepX, stepY);
    }
  }
  
  
  /**
   * Move multiple items
   *
   * @param stepX
   * @param stepY
   */
  public moveMultibleItems(stepX,
                           stepY) {
    const selectedItems = this._container.selection,
      relativeDelta = this._container.getRelativeDelta(
        stepX,
        stepY
      );
    this._commandMoveMultipleItems(selectedItems, relativeDelta);
  }

  /**
   * Event keyup
   *
   * @protected
   */
  protected _keyUp() {
    if (this.selfMarker) {
      this.selfMarker._cmdPressed = false;
    }
  }

  /**
   * Handle mouse over
   *
   * @param event
   * @protected
   */
  protected _handleMouseMove(event) {
    if (this.self._container.isDrawing) {
      return;
    }
    this._segment = null;
    this._lastPoint = this.self._localPaper.view.projectToView(event.point);
    this._hitResults = this.self._localPaper.project.hitTestAll(event.point, Object.assign({hidden: true}, this.self._hitOptions));
    this._hitResult = this._hitResults
      .find(h => h.item && h.item.marker && (h.item.marker._model.annotation).type === FlatModels.AnnotationEntityModels.AnnotationType.enum.Marker);
    if (!this._hitResult) {
      this._hitResult = this._hitResults[0];
    }
    this._segment = this._hitResult;

    if (!this._hitResult) {
      this.self.emit('overImage', {event});
      this.self.emit('unoverMarker');
      return;
    }
    const marker = (this._hitResult.item &&
      this._hitResult.item.marker &&
      (this._hitResult.item.marker._model.annotation).type === FlatModels.AnnotationEntityModels.AnnotationType.enum.Marker) ?
      this._hitResult.item.marker :
      null;
    const keymap = (this._hitResult.item && this._hitResult.item.keymap) ? this._hitResult.item.keymap : null;
    let freeform = (this._hitResult.item && this._hitResult.item.freeform) ? this._hitResult.item.freeform : null;
    const virtualPointer = (this._hitResult.item && this._hitResult.item.sprite) ? this._hitResult.item.sprite : null;
    
    freeform = (this._hitResult.item &&
      this._hitResult.item.marker &&
      (this._hitResult.item.marker._model.annotation).type === FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) ?
      this._hitResult.item.marker :
      freeform;

    switch (this._hitResult.type) {
      case 'fill':
        if (!(marker || keymap || freeform)) {
          this.self.emit('unoverMarker');
          return;
        }
        this._hitResult.item.parent.bringToFront();
        if (marker && marker.model && marker.model.targets && marker.model.targets.length > 0) {
          this.self._startPoints = this.self._container.getAbsoluteCoords(
            marker.model.targets[0].x,
            marker.model.targets[0].y,
            this._imageOffset,
            this._imageScale
          );
        }
        if (marker) {
          this.self.emit('overMarker', {item: marker});
        } else if (keymap) {
          this.self.emit('overKeymap', {item: keymap});
        } else if (freeform) {
          this.self.emit('overFreeform', {item: freeform});
        }
        break;

      case 'pixel':
        if (virtualPointer) {
          if (virtualPointer.isMovable) {
            this.self.emit('overVirtualPointer', {item: virtualPointer});
          } else {
            this.self.emit('unoverMarker');
          }
        } else {
          const image = this.self._container.getElementById('image');
          if (image) {
            this.self.emit('overImage', {item: image});
          } else {
            this.self.emit('unoverMarker');
          }
        }
        break;

      case 'stroke':
      case 'segment':
        if (!(marker || keymap || freeform)) {
          this.self.emit('unoverMarker');
          return;
        }
        this._hitResult.item.parent.bringToFront();
        if (marker) {
          this.self.emit('overMarker', {item: marker});
        } else if (keymap) {
          this.self.emit('overKeymap', {item: keymap});
        } else if (freeform) {
          this.self.emit('overFreeform', {item: freeform});
        }
        break;
      default:
        if (marker && marker.isMovable) {
          this.self.emit('overMarker', {item: this._hitResult.item.class});
        } else {
          this.self.emit('unoverMarker');
        }
        break;
    }
  }

  /**
   * Handle mouse down
   *
   * @param event
   * @protected
   */
  protected _handleMouseDown(event) {
    if (this.self._container.isDrawing) {
      return;
    }
    
    this._segment = null;
    this._lastPoint = this.self._localPaper.view.projectToView(event.point);
    this._hitResults = this.self._localPaper.project.hitTestAll(event.point, this.self._hitOptions);
    this._hitResult = this._hitResults
      .find(h => h.item && h.item.marker && (h.item.marker._model.annotation).type === FlatModels.AnnotationEntityModels.AnnotationType.enum.Marker);
    if (!this._hitResult) {
      this._hitResult = this._hitResults[0];
    }
    this._segment = this._hitResult;

    const addToSelection = !!event.event.shiftKey;
    if (!this._hitResult) {
      this.self.emit('selectImage', {event});
      this.self.emit('unselectMarker');
      return;
    }
    if (this.self._container.allSelected && this._hitResult.type !== 'fill') {
      return;
    }
    if (this.self._container.selection.length > 1 && (this._hitResult.type !== 'fill' && this._hitResult.type !== 'pixel')) {
      return;
    }
    const marker = (this._hitResult.item && this._hitResult.item.marker &&
      this._hitResult.item.marker._model.annotation.type === FlatModels.AnnotationEntityModels.AnnotationType.enum.Marker) ?
      this._hitResult.item.marker :
      null;
    const keymap = (this._hitResult.item && this._hitResult.item.keymap) ? this._hitResult.item.keymap : null;
    let freeform = (this._hitResult.item && this._hitResult.item.freeform) ? this._hitResult.item.freeform : null;
    const virtualPointer = (this._hitResult.item && this._hitResult.item.sprite) ? this._hitResult.item.sprite : null;
    
    freeform = (this._hitResult.item &&
      this._hitResult.item.marker &&
      (this._hitResult.item.marker._model.annotation).type === FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) ?
      this._hitResult.item.marker :
      freeform;

    switch (this._hitResult.type) {
      case 'fill':
        if (!(marker || keymap || freeform)) {
          this.self.emit('unselectMarker');
          return;
        }
        this._hitResult.item.parent.bringToFront();
        if (marker && marker.model && marker.model.targets && marker.model.targets.length > 0) {
          this.self._startPoints = this.self._container.getAbsoluteCoordsMarkerTool(
            marker.model.targets[0].x,
            marker.model.targets[0].y
          );
        }
        if (marker) {
          this.self.emit('selectMarker', {
            item: marker,
            event: event,
            add: addToSelection,
            hitResult: this._hitResult
          });
        } else if (keymap) {
          this.self.emit('selectKeymap', {
            item: keymap,
            event: event,
            add: addToSelection,
            hitResult: this._hitResult
          });
        } else if (freeform) {
          this.self.emit('selectFreeform', {
            item: freeform,
            event: event,
            add: addToSelection,
            hitResult: this._hitResult
          });
        }
        break;

      case 'pixel':
        if (virtualPointer) {
          if (virtualPointer.isMovable) {
            this.self.emit('unselectMarker');
            this.self.emit('selectVirtualPointer', {
              item: virtualPointer,
              event: event,
              add: addToSelection,
              hitResult: this._hitResult
            });
          } else {
            this.self.emit('unselectMarker');
          }
        } else {
          const image = this.self._container.getElementById('image');
          if (image) {
            this.self.emit('unselectMarker');
            this.self.emit('selectImage', {
              item: image,
              event: event
            });
          }
          this.self.emit('unselectMarker');
        }
        break;

      case 'stroke':
      case 'segment':
        if (!(marker || keymap || freeform)) {
          return;
        }
        this._hitResult.item.parent.bringToFront();
        if (marker) {
          this.self.emit('selectMarker', {
            item: marker,
            event: event,
            add: addToSelection,
            hitResult: this._hitResult
          });
        } else if (keymap) {
          this.self.emit('selectKeymap', {
            item: keymap,
            event: event,
            add: addToSelection,
            hitResult: this._hitResult
          });
        } else if (freeform) {
          this.self.emit('selectFreeform', {
            item: freeform,
            event: event,
            add: addToSelection,
            hitResult: this._hitResult
          });
        }
        break;
      default:
        if (marker && marker.isMovable) {
          this.self.emit('selectMarker', {
            item: this._hitResult.item.class,
            event: event,
            add: addToSelection,
            hitResult: this._hitResult
          });
        } else {
          this.self.emit('unselectMarker');
        }
        break;
    }
  }

  /**
   * Handle mouse drag
   *
   * @param event
   * @protected
   */
  protected _handleMouseDrag(event) {
    if (this.self._container.isDrawing) {
      return;
    }
    if (!this._hitResult) {
      return;
    }
    const marker = (this._hitResult.item && this._hitResult.item.marker) ? this._hitResult.item.marker : null;
    const keymap = (this._hitResult.item && this._hitResult.item.keymap) ? this._hitResult.item.keymap : null;
    let freeform = (this._hitResult.item && this._hitResult.item.freeform) ? this._hitResult.item.freeform : null;
    const virtualPointer = (this._hitResult.item && this._hitResult.item.sprite) ? this._hitResult.item.sprite : null;
    
    freeform = (this._hitResult.item &&
      this._hitResult.item.marker &&
      (this._hitResult.item.marker._model.annotation).type === FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) ?
      this._hitResult.item.marker :
      freeform;

    if (this.self._container.selection.length > 1) {
      this.self.emit('moveItem', { item: undefined });
      this.self.moveMultibleItems(event.delta.x, event.delta.y);
      return;
    }
    switch (this._hitResult.type) {
      case 'stroke':
        if (this._segment.item.data.selectionType === 'label') {
          if (marker || freeform) {
            this.self.emit('moveItem', { item: marker || freeform });
            this.self.moveLabel(marker, event);
          }
        } else if (this._segment.item.data.selectionType === 'segment') {
          if (freeform) {
            this.self.emit('moveItem', { item: freeform });
            this.self.moveSegment(freeform, event, this._hitResult.item.positionInPath);
          }
        } else if (this._segment.item.data.selectionType === 'resize') {
          this.self.emit('moveItem', { item: freeform });
          this.self.resizeFreeform(freeform, event);
        } else if (keymap) {
          this.self.emit('moveItem', { item: keymap });
          this.self.moveKeymap(keymap, event);
        } else if (freeform) {
          this.self.emit('moveItem', { item: freeform });
          this.self.moveObject(freeform, event);
        } else {
          if (marker || freeform) {
            this.self.emit('moveItem', { item: marker || freeform });
            this.self.movePointer(marker || freeform, event);
          }
        }
        break;

      case 'fill':
        if (this._segment.item.data.selectionType === 'label') {
          if (marker || freeform) {
            this.self.emit('moveItem', { item: marker || freeform });
            this.self.moveLabel(marker || freeform, event);
          }
        } else if (this._segment.item.data.selectionType === 'fork') {
          if (marker || freeform) {
            this.self.emit('moveItem', { item: marker || freeform });
            this.self.moveFork(marker || freeform, event);
          }
        } else if (this._segment.item.data.selectionType === 'segment') {
          if (freeform) {
            this.self.emit('moveItem', { item: freeform });
            this.self.moveSegment(freeform, event, this._hitResult.item.positionInPath);
          }
        } else if (this._segment.item.data.selectionType === 'resize') {
          this.self.emit('moveItem', { item: freeform });
          this.self.resizeFreeform(freeform, event);
        } else if (keymap) {
          this.self.emit('moveItem', { item: keymap });
          this.self.moveKeymap(keymap, event);
        } else if (freeform) {
          this.self.emit('moveItem', { item: freeform });
          this.self.moveObject(freeform, event, this._hitResult.item.positionInPath);
        } else {
          if (marker.model.targets && marker.model.targets.length > 0 && Number.isFinite(this._segment.item.data.index)) {
            this.self.emit('moveItem', { item: marker });
            this.self.moveTarget(marker, event, this._segment.item.data.index);
          }
        }
        break;

      case 'pixel':
        if (this.self._container.getElementById('image').isMovable) {
          this.self.emit('moveItem', { item: undefined });
          this.self.moveImage(event);
        }
        break;

      case 'segment':
        if (this._segment.item.data.selectionType === 'fork') {
          if (marker || freeform) {
            this.self.emit('moveItem', { item: marker || freeform });
            this.self.moveFork(marker || freeform, event);
          }
        } else if (this._segment.item.data.selectionType === 'label') {
          if (marker || freeform) {
            this.self.emit('moveItem', { item: marker || freeform });
            this.self.moveLabel(marker || freeform, event);
          }
        } else if (freeform) {
          if (freeform && freeform._model &&
            (freeform._model.annotation.shape === 'free' || freeform._model.annotation.shape === 'line')) {
            this.self.emit('moveItem', { item: freeform });
            this.self.moveSegment(freeform, event, this._hitResult.item.positionInPath);
          } else {
            this.self.emit('moveItem', { item: freeform });
            this.self.resizeFreeform(freeform, event);
          }
        } else {
          if (marker && marker.model.targets && marker.model.targets.length > 0 && Number.isFinite(this._segment.item.data.index)) {
            this.self.emit('moveItem', { item: marker });
            this.self.moveTarget(marker, event, this._segment.item.data.index);
          }
        }
        break;
    }
  }

  /**
   * Move label
   *
   * @param marker
   * @param event
   */
  public moveLabel(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                   event) {
    let relativeCoords;
    const absoluteCoords = this._container.getAbsoluteCoordsMarkerTool(
      marker.model.source.position.x,
      marker.model.source.position.y
    );
    const delta = event.pointerType === 'mouse' ? this._container.getAbsoluteDelta(event.delta.x, event.delta.y) : event.delta;
    if (event.event.shiftKey) {
      if (marker.model.annotation && marker.model.annotation.fork) {
        const absoluteCoordsFork = this._container.getAbsoluteCoordsMarkerTool(
          marker.model.annotation.fork.x,
          marker.model.annotation.fork.y
        );
        relativeCoords = this._snapToAngle(absoluteCoordsFork, delta, absoluteCoords);
      } else {
        relativeCoords = this._snapToAngle(this._startPoints, delta, absoluteCoords);
      }
    } else {
      relativeCoords = this._container.getRelativeCoords(
        absoluteCoords.x + delta.x,
        absoluteCoords.y + delta.y
      );
    }
    if (isNaN(relativeCoords?.x)) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.relative_coords_not_a_number',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "APPS.Author.markerTool.moveLabel"
      );
    }
    this._commandMoveLabel(marker, relativeCoords);
  }

  /**
   * Move Fork
   *
   * @param marker
   * @param event
   */
  public moveFork(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                  event) {
    if (_preventMoving) {
      return;
    }

    const relativeDelta = this._container.getRelativeDelta(
        event.delta.x,
        event.delta.y
    );

    if (event.event.altKey) {
      marker.model.annotation.fork.x = null;
      marker.model.annotation.fork.y = null;
      this._emitData = {
        type: 'updateMarkerFork',
        data: {
          marker: marker.model.annotation,
          name: 'history.marker_update_fork_position'
        }
      };
      this.emit('updateAnnotation');
    } else {
      if (!marker.model.annotation.fork.x && !marker.model.annotation.fork.y) {
        marker.model.annotation.fork = (JSON.parse(JSON.stringify(marker.model.source.position)));
      }

      const position = {
        x: marker.model.annotation.fork.x + relativeDelta.x,
        y: marker.model.annotation.fork.y + relativeDelta.y
      };

      if (event.event.shiftKey) {
        const deltaX = marker.model.source.position.x - position.x;
        const deltaY = marker.model.source.position.y - position.y;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const dir = Math.round(Math.atan2(deltaY, deltaX)/Math.PI*180/45) * 45;
        position.x = marker.model.source.position.x - Math.cos(dir / 180 * Math.PI) * distance
        position.y = marker.model.source.position.y - Math.sin(dir / 180 * Math.PI) * distance
      }

      this._commandMoveFork(marker, position);
    }
  }

  /**
   * Move target
   *
   * @param marker
   * @param event
   * @param index
   */
  public moveTarget(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                    event,
                    index) {
    const relativeDelta = this._container.getRelativeDelta(
      event.delta.x,
      event.delta.y
    );
    this._commandMoveTarget(marker, index, relativeDelta);
  }

  /**
   * Move pointer
   *
   * @param marker
   * @param event
   */
  public movePointer(marker: { model: FlatModels.ImageSharedModels.MarkerModel },
                     event) {
    const relativeDelta = this._container.getRelativeDelta(
      event.delta.x,
      event.delta.y
    );
    this._commandMovePointer(marker, relativeDelta);
  }

  /**
   * Move keymap
   *
   * @param keymap
   * @param event
   */
  public moveKeymap(keymap: { model: FlatModels.ImageSharedModels.KeymapModel },
                    event) {
    const relativeDelta = this._container.getRelativeDelta(
      event.delta.x,
      event.delta.y
    );
    this._commandMoveKeymap(keymap, relativeDelta);
  }

  /**
   * Move object
   *
   * @param freeform
   * @param event
   * @param index
   */
  public moveObject(freeform: { model: FlatModels.ImageSharedModels.FreeformModel },
                    event,
                    index?) {
    const relativeDelta = this._container.getRelativeDelta(
      event.delta.x,
      event.delta.y
    );
    this._commandMoveObject(freeform, relativeDelta, index);
  }

  /**
   * Move segment
   *
   * @param freeform
   * @param event
   * @param index
   */
  public moveSegment(freeform: { model: FlatModels.ImageSharedModels.FreeformModel },
                     event,
                     index) {
    const relativeDelta = this._container.getRelativeDelta(
      event.delta.x,
      event.delta.y
    );
    this._commandMoveSegment(freeform, relativeDelta, index);
  }

  /**
   * Resize freeform
   *
   * @param freeform
   * @param event
   */
  public resizeFreeform(freeform: { model: FlatModels.ImageSharedModels.FreeformModel },
                        event) {
    const relativeDelta = this._container.getRelativeDelta(
      event.delta.x,
      event.delta.y
    );

    if (event.event.shiftKey) {
      relativeDelta.y = relativeDelta.x;
    }
    this._commandResizeFreeform(freeform, relativeDelta);
  }

  /**
   * Move image
   *
   * @param event
   */
  public moveImage(event) {
    const absoluteCoords = this._container.getAbsoluteCoords(
      this.slide.fields.image[this.sequenceId].offset.x,
      this.slide.fields.image[this.sequenceId].offset.y,
      this._imageOffset,
      this._imageScale
    );
    const relativeCoords = this._container.getRelativeCoords(
      absoluteCoords.x + event.delta.x,
      absoluteCoords.y + event.delta.y
    );
    this._commandMoveImage(this.slide.fields.image[this.sequenceId], relativeCoords);
  }

  /**
   * Move virtualpointer
   *
   * @param virtualPointer
   * @param event
   */
  public moveVirtualPointer(virtualPointer,
                            event) {
    const relativeDelta = this._container.getAbsoluteDelta(
      event.delta.x,
      event.delta.y
    );
    this._commandMoveVirtualPointer(virtualPointer, relativeDelta);
  }

  /**
   * Snap to angle
   *
   * @param startPoints
   * @param absoluteCoords
   * @param delta
   * @returns {{x: number, y: number}}
   * @protected
   */
  protected _snapToAngle(startPoints,
                         absoluteCoords,
                         delta) {
    const startX = startPoints.x,
      startY = startPoints.y,
      x2 = (absoluteCoords.x + delta.x) - startX,
      y2 = (absoluteCoords.y + delta.y) - startY,
      r = Math.sqrt(x2 * x2 + y2 * y2);
    let angle = (Math.atan2(y2, x2) / Math.PI * 180);
    angle = (angle) % 360 + 180;
    angle = (((angle + 22.4) % 360) / 45) * 45;
    angle -= 180;
    const cosx = r * Math.cos(angle * Math.PI / 180),
      sinx = r * Math.sin(angle * Math.PI / 180);
    return this._container.getRelativeCoords(
      cosx + startX,
      sinx + startY
    );
  }

  /**
   * Handle mouse up
   *
   * @protected
   */
  protected _handleMouseUp() {
    if (this.self._container.isDrawing) {
      return;
    }
    this._segment = null;
    this._isMouseDown = false;
    _preventMoving = false;
    this.self.emit('endMoveItem');
    if (this.self._emitData) {
      this.self.emit(this.self._emitData.type, this.self._emitData.data);
      this.self._emitData = null;
    }
  }

  /**
   * Move Segment
   *
   * @param freeform
   * @param value
   * @param index
   */
  protected _moveSegment(freeform: FlatModels.ImageSharedModels.FreeformModel,
                         value,
                         index) {
    if (freeform.annotation.shape === 'free' || freeform.annotation.shape === 'interactiveArea') {
      if (freeform.annotation.path[index]) {
        freeform.annotation.path[index].x += this._round(value.x, 4);
        freeform.annotation.path[index].y += this._round(value.y, 4);
        this._emitData = {
          type: 'updateFreeformPath',
          data: {
            freeform: freeform.annotation,
            name: 'history.free_form_update_path_position'
          }
        };
      }
    } else {
      if (index === 0) {
        this._addSource(freeform, value);
      } else {
        this._resize(freeform, value);
      }
    }
  }

  /**
   * Add Source
   *
   * @param freeform
   * @param value
   * @protected
   */
  protected _addSource(freeform: FlatModels.ImageSharedModels.FreeformModel,
                       value) {
    if (freeform.annotation.shape === 'free' || freeform.annotation.shape === 'interactiveArea') {
      freeform.annotation.path.map(pathPoint => {
        pathPoint.x += this._round(value.x, 4);
        pathPoint.y += this._round(value.y, 4);
      });
      this._emitData = {
        type: 'updateFreeformPath',
        data: {
          freeform: freeform.annotation,
          name: 'history.free_form_update_path_position'
        }
      };
    } else {
      freeform.source.position.x += this._round(value.x, 4);
      freeform.source.position.y += this._round(value.y, 4);
      this._emitData = {
        type: 'updateFreeformSource',
        data: {
          source: freeform.source,
          name: 'history.free_form_update_source_position'
        }
      };
    }
  }

  /**
   * Resize
   *
   * @param freeform
   * @param value
   * @protected
   */
  protected _resize(freeform: FlatModels.ImageSharedModels.FreeformModel,
                    value) {
    freeform.freeFormStyle.width += this._round(value.x, 4);
    freeform.freeFormStyle.height += this._round(value.y, 4);
    this._emitData = {
      type: 'updateFreeformStyle',
      data: {
        style: freeform.freeFormStyle,
        name: 'history.free_form_update_style'
      }
    };
  }

  /**
   * Round
   *
   * @param number
   * @param precision
   */
  public _round(number, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = number * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
  }

  /**
   * Getter lockimage
   *
   * @returns {*}
   */
  public get lockimage() {
    return this._lockimage;
  }

  /**
   * Setter lockimage
   *
   * @param lockimage
   */
  public set lockimage(lockimage) {
    this._lockimage = lockimage;
  }
}
